export default __webpack_public_path__ + "media/Objective/Objective-Light-Italic-766821ff537e1503129eed531c16ed84.woff2";